type TProp = {
    size: number;
};

export default function SpacerRow({size}: TProp)
{
    return (
        <div><div style={{width: `${size}rem`}}></div></div>
    )
}